<template>
  <base-dialog width="485px" class="confirm-dialog" :visible.sync="visible">
    <template #header>
      {{ title }}
    </template>
    <div class="body-wrapper">
      {{ tip }}
    </div>
    <template #footer>
      <base-button @click="$emit('cancel'), (visible = false)">{{ cancelButtonText }}</base-button>
      <base-button type="primary" @click="submit">
        {{ confirmButtonText }}
      </base-button>
    </template>
  </base-dialog>
</template>

<script>
import BaseButton from "@/components/UIComponents/Button"
import BaseDialog from "@/components/UIComponents/BaseDialog.vue"

export default {
  name: "PromptDialog",
  components: { BaseButton, BaseDialog },
  props: {
    title: {
      type: String,
      default: "提示"
    },
    tip: {
      type: String,
      default: "请输入"
    },
    confirmButtonText: {
      type: String,
      default: "确定"
    },
    cancelButtonText: {
      type: String,
      default: "取消"
    }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    open() {
      this.visible = true
    },
    submit() {
      this.$emit("confirm")
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.confirm-dialog {
  .body-wrapper {
    font-size: 14px;
    margin-bottom: 10px;
  }
}
</style>
